import type { LoginOptions } from "@dotcom/oauthjs";
import { envConfig } from "./envConfigs";

export const oauthConfig: LoginOptions = {
  allowIframeLoginWithoutPromptNone: false,
  authOpts: {
    redirect_uri: "/support/storeappointment/customer/",
    scope: "urn:convoy:security:token:client-credentials urn:convoy:user#read urn:csp:scope:self-help:user:me",
  },
  authorizeUrl: "https://oauth.xfinity.com/oauth/authorize",
  iframeRedirectUri: "/support/storeappointment/token.html",
  redirect: true,
  useIframe: false,
  ...envConfig.oauthConfig,
};
